import { useI18n } from '@cvo/i18n/composables/useI18n';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export function useStation(stationCode?: MaybeRefOrGetter<string | undefined>) {
  const { tf } = useI18n();

  /** Try to retrieve the station name by fallbacking from stationGroups > cities > airports */
  function getStationName(station: string) {
    return tf(`stationGroups.${station}.name`, tf(`cities.${station}.name`, tf(`airports.${station}.name`, station)));
  }

  const stationName = computed<string | undefined>(() => {
    const code = toValue(stationCode);
    if (!code) return undefined;

    return getStationName(code);
  });

  return {
    stationName,
    getStationName,
  };
}